"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNumber = exports.isTrue = void 0;
function isTrue(value) {
    return String(value).toLowerCase() === "true";
}
exports.isTrue = isTrue;
function isNumber(value) {
    return !isNaN(Number(value));
}
exports.isNumber = isNumber;
//# sourceMappingURL=option-utils.js.map